import React from 'react';
import _ from 'lodash';
import { ADDONS_LIST, ADDONS }  from '../../constants/servicesList';
import { Table } from 'antd';

const columns = [
    {
        title: 'Addon Name',
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: 'Price',
        dataIndex: 'price',
        key: 'price',
    },
];

function createTableData() {
    const data = _.cloneDeep(ADDONS_LIST);

    data.push(ADDONS.velux_roof_window);

    return data.map(item => {
        return {
            key: item.id,
            name: item.label,
            price: item.id === ADDONS.velux_roof_window.id ? `£${item.price} per window` : `£${item.price}`,
        };
    });
}

const AddonsTable = () => {
    return (
        <Table
            dataSource={createTableData()}
            columns={columns}
            pagination={false}
            bordered
        />
    );
};

export default AddonsTable;
